module.exports = __webpack_public_path__ + "static/media/ZhiXiao4.823b62dd.png";